import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import API from "./pages/API";
import CheckStatus from "./pages/CheckStatus";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import CreateTicket from "./pages/CreateTicket";
import DashboardAppPage from "./pages/DashboardAppPage";
import Escalationmatrix from "./pages/Escalationmatrix";
import UserManual from "./pages/UserManual";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminDashboardLayout from "./admin/componants/Nav-section/AdminDashboardLayout";
import SendMail from "./admin/pages/SendMail";
import AddUser from "./admin/pages/AddUser";
import CompanyDetails from "./admin/pages/CompanyDetails";
import Invoicepdf from "./pages/Invoicepdf";
import CompanyStatus from "./admin/pages/CompanyStatus";
import Login from "./pages/Login";
import { usePreviousUrl } from "./hooks/usePreviousUrl";

export default function Router() {
  const previousUrl = usePreviousUrl();

  const routes = useRoutes([
    {
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to={'/dashboard'} />, index: true },
        { path: "/dashboard", element: <DashboardAppPage /> },
        { path: "/reportissue", element: <CreateTicket /> },
        { path: "/checkstatus", element: <CheckStatus /> },
        { path: "/checkstatus/:ticketId", element: <CheckStatus /> },
        { path: "/API", element: <API /> },
        { path: "/escalation", element: <Escalationmatrix /> },
        { path: "/usermanual", element: <UserManual /> },
      ],
    },
    {
      path: "/login",
      element: <LoginPage previousUrl={previousUrl} />,
    },
    {
      path: "/signin",
      element: <Login />,
    },
    {
      path: "invoicePdf",
      element: <Invoicepdf />,
    },
    {
      path: "adminLogin",
      element: <AdminLogin />,
    },
    {
      element: <AdminDashboardLayout />,
      children: [
        { element: <Navigate to='/sendmail' />, index: true },
        { path: "/sendmail", element: <SendMail /> },
        { path: "/addUser", element: <AddUser /> },
        { path: "/companydetails", element: <CompanyDetails /> },
        { path: "/changestatus", element: <CompanyStatus /> },
      ],
    },
    {
      children: [
        { element: <Navigate to='/dashboard' />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to='/404' /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to='/404' replace />,
    },
  ]);

  return routes;
}
